export default __webpack_public_path__ + "static/Fellix-Thin-7f5978a2bfc9132a4c38fb43ccb9cc2d.otf";